import { Backdrop, Box, Checkbox, Collapse, FormControlLabel, Slide, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import CustomInput from './CustomInput';
import { useState } from 'react';
import { afterValidate, generateLighterContrastColor, setInput } from '../../../utils/commonServices';
import { getErrorMsg } from '../../../utils/validator';
import DownIcon from '../icons/DownIcon';
import UpIcon from '../icons/UpIcon';
// import { customTheme as theme } from '../../../theme/customTheme';
import { getContrastRatio } from '@mui/material/styles';
import useCustomTheme from '../../../theme/useCustomTheme';
import useHubspotSafeMargin from '../../../hooks/useHubspotSafeMargin';

const OPENING_TYPE_OPTIONS = [
    { value: 'logo', label: 'Logo', description: 'Uses your company logo from Brand Box' },
    { value: 'text', label: 'Text', description: 'Show custom text at the start of your video' },
    { value: 'none', label: 'No Opening', description: 'No opening graphic or text' },
]

const ProjectNamePage = (props) => {

    const {pageData, setPageData, slideDirection, nextPageHandler, prevPageHandler, pageIndex, selectedProjectType, setSelectedProjectType, totalScreens, closeHandler} = props
    const createEventReducer = useSelector((state) => state.createEventReducer);
    const dispatch = useDispatch()
    const [nameValidationFlag, setNameValidationFlag] = useState(false);
    const [openingTextValidationFlag, setOpeningTextValidationFlag] = useState(false);
    const [nameTooltip, setNametooltip] = useState(false)
    const [theme ] = useCustomTheme()
    const hubspotSafeMr = useHubspotSafeMargin(40)
    const contentRef = useRef(null)

    // Once the opening-text field has fully expanded, bring it (and the checkbox) into
    // view when the slide overflows the viewport. A no-op when everything already fits.
    const scrollToOpeningText = () => {
        const el = contentRef.current
        if (!el || el.scrollHeight <= el.clientHeight) return
        const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches
        el.scrollTo({ top: el.scrollHeight, behavior: reduceMotion ? 'auto' : 'smooth' })
    }

    const openingType = pageData?.opening_type || 'logo'
    // The checkbox is "on" whenever the opening text currently equals the project name.
    const useNameAsOpeningText = !!pageData?.name && pageData?.opening_text === pageData?.name

    const finishedHandler = ()=> {
        validateInputs(true)
        afterValidate(nextPageHandler);
    }

    const validateInputs = (flag) => {
        setNameValidationFlag(flag)
        setOpeningTextValidationFlag(flag)
    }

    const selectOpeningType = (value) => {
        setInput(value, 'opening_type', pageData, setPageData)
    }

    const handleOpeningTextChange = (value) => {
        // Strip 4-byte UTF-8 characters (emoji / beyond-BMP) that the MySQL utf8
        // `opening_text` column can't store and that otherwise 422 the API on submit.
        const sanitized = value.replace(/[\u{10000}-\u{10FFFF}]/gu, '')
        setInput(sanitized, 'opening_text', pageData, setPageData)
    }

    // Toggle: fill the opening text with the project name, or clear it when unchecked.
    const toggleUseNameAsOpeningText = (checked) => {
        setInput(checked ? (pageData?.name || '') : '', 'opening_text', pageData, setPageData)
    }

    useEffect(() => {
      const keyDownHandler = (event) => {
        // console.log("key Parent", event.key)
        if (event.key === "Enter") {
          event.preventDefault();
  
          finishedHandler();
        }
      };
        document.addEventListener("keydown", keyDownHandler)
        
      return () => {
        document.removeEventListener("keydown", keyDownHandler);
      };
    }, [pageData]);


  return (
    <>
    <Slide direction={slideDirection} in={true} mountOnEnter unmountOnExit>
    <Backdrop
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 , backdropFilter: 'blur(23px) !important', display:'flex', flexDirection:'column', background: '#08231B99 0% 0% no-repeat padding-box', }}
    open={createEventReducer.open_backdrop_project_creation}
    >
        <Box sx={{ width:'100%', height:'100%', display:'flex', flexDirection:'column'}}>
          <Typography textAlign={'right'} sx={{fontSize:'16px', cursor:'pointer', mt:5, mr:3, fontFamily:'Rubik'}} onClick={closeHandler}>Close X</Typography>
          <Box ref={contentRef} flexGrow={1} className='flex col ' sx={{ paddingLeft:'14vw', paddingRight:{xs:'6vw',sm:'4vw'}, marginTop:{xs:'20%',sm:'14%',md:'8%', lg:'7%'}, minHeight:0, overflowY:'auto', overscrollBehavior:'contain', paddingBottom:{xs:'16px',sm:'24px'} }}>
              <Box mb={6}>
                <Typography sx={{fontSize:{xs:'15px',sm:'18px',md:'22px',lg:'24px',xl:'35px'}, color:'white', fontFamily:'Rubik'}}>{`${pageIndex}/${totalScreens}`}</Typography>
                <Typography sx={{fontSize:{xs:'30px',sm:'35px',md:'40px',lg:'45px',xl:'65px'}, color:'white', fontFamily:'Rubik'}}>What's your project name?</Typography>
                <Typography sx={{fontSize:{xs:'15px',sm:'18px',md:'22px',lg:'24px',xl:'35px'}, color:'white', fontFamily:'Rubik'}}>Give your project a name so you can easily find it in your dashboard.</Typography>
              </Box>
              <Box className='flex' sx={{width:'80%'}}>
              <CustomInput
                // id= {errorObjectArray[0]?.id}
                onFocus={() =>{ setNameValidationFlag(false); setTimeout(()=>{setNametooltip(true)},[1500]) }}
                onBlur={() => setNameValidationFlag(true)}
                type='sendInput'
                required
                medium
                errorFlag={
                  nameValidationFlag &&
                  getErrorMsg("project_name", pageData?.name) != ""
                }
                errorMsg={getErrorMsg("project_name", pageData?.name)}
                fullWidth
                max={100}
                placeholder="Lucihub Project Name (Max Character 100)"
                onChange={(event) => {
                  setNametooltip(false)
                  setInput(event.target.value, "name", pageData, setPageData)
                }}
                value={pageData?.name}
                bottom={-20}
                msgColor='red'
                onButtonClick={pageIndex !== 8 ? finishedHandler : null}
               />
              </Box>

              <Box mt={{xs:4,sm:6}}>
                <Typography sx={{fontSize:{xs:'15px',sm:'18px',md:'22px',lg:'24px',xl:'35px'}, color:'white', fontFamily:'Rubik'}}>How would you like your video to open?</Typography>
              </Box>
              <Box className='flex' gap={{xs:2,sm:5,md:6,lg:8,xl:10}} mt={{xs:0.5,sm:0.8,md:1,xl:1.2}} sx={{ flexDirection: {xs:'column', sm:'row'}, width:{xs:'90%',sm:'100%'} }}>
                {OPENING_TYPE_OPTIONS.map((option) => {
                  const isSelected = openingType === option.value
                  return (
                    <Box
                      key={option.value}
                      onClick={() => selectOpeningType(option.value)}
                      className='flex'
                      gap={1.2}
                      sx={{cursor:'pointer', alignItems:'flex-start', maxWidth:{sm:'220px',md:'250px',xl:'340px'}}}
                    >
                      <Box sx={{
                        width:{xs:'16px',sm:'18px',xl:'24px'},
                        height:{xs:'16px',sm:'18px',xl:'24px'},
                        borderRadius:'50%',
                        border: `1.5px solid ${isSelected ? theme.palette.primary.main : 'rgba(255,255,255,0.6)'}`,
                        display:'flex', alignItems:'center', justifyContent:'center',
                        flexShrink:0, mt:'3px'
                      }}>
                        {isSelected && <Box sx={{width:'55%', height:'55%', borderRadius:'50%', backgroundColor: theme.palette.primary.main}} />}
                      </Box>
                      <Box>
                        <Typography sx={{fontSize:{xs:'14px',sm:'16px',md:'17px',lg:'18px',xl:'25px'}, color:'white', fontFamily:'Rubik', fontWeight:600}}>{option.label}</Typography>
                        <Typography sx={{fontSize:{xs:'10px',sm:'11.5px',md:'12.5px',lg:'14px',xl:'18px'}, color:'#cfd6d3', fontFamily:'Rubik', mt:'2px'}}>{option.description}</Typography>
                      </Box>
                    </Box>
                  )
                })}
              </Box>

              <Collapse in={openingType === 'text'} timeout={350} unmountOnExit onEntered={scrollToOpeningText}>
                <Box mt={{xs:3,sm:5}} sx={{width:'80%'}}>
                  <Typography sx={{fontSize:{xs:'15px',sm:'18px',md:'22px',lg:'24px',xl:'35px'}, color:'white', fontFamily:'Rubik'}}>Opening text</Typography>
                  <Typography sx={{fontSize:{xs:'11px',sm:'13px',md:'15px',lg:'16px',xl:'22px'}, color:'#cfd6d3', fontFamily:'Rubik', mb:{xs:1,sm:1.5}}}>Enter the text you'd like shown at the beginning of your video.</Typography>
                  <Box className='flex'>
                    <CustomInput
                      onFocus={() => setOpeningTextValidationFlag(false)}
                      onBlur={() => setOpeningTextValidationFlag(true)}
                      type='text'
                      required
                      medium
                      errorFlag={openingTextValidationFlag && getErrorMsg("opening_text", pageData?.opening_text) != ""}
                      errorMsg={getErrorMsg("opening_text", pageData?.opening_text)}
                      fullWidth
                      max={100}
                      placeholder="Opening Text (Max Character 100)"
                      onChange={(event) => handleOpeningTextChange(event.target.value)}
                      value={pageData?.opening_text}
                      bottom={-20}
                      msgColor='red'
                    />
                  </Box>
                  <FormControlLabel
                    sx={{ mt:{xs:0.5,sm:1}, ml:0, alignItems:'center' }}
                    control={
                      <Checkbox
                        checked={useNameAsOpeningText}
                        onChange={(event) => toggleUseNameAsOpeningText(event.target.checked)}
                        sx={{ p:0, mr:1, color:'rgba(255,255,255,0.6)', '&.Mui-checked': { color: theme.palette.primary.main } }}
                      />
                    }
                    label={<Typography sx={{fontSize:{xs:'11px',sm:'13px',md:'14px',lg:'15px',xl:'20px'}, color:'white', fontFamily:'Rubik'}}>Use project name as opening title</Typography>}
                  />
                </Box>
              </Collapse>
          </Box>
          <Box className='flex' sx={{justifyContent:'flex-end', mb:5, mr:`${hubspotSafeMr}px`}}>
            {/* <Box className='flex a-center j-center' sx={{height:'40px', width:'40px', backgroundColor:'green', cursor:'pointer', opacity: pageIndex === 1 && 0.5}} onClick={pageIndex !== 1 ? prevPageHandler : null}>/\</Box> */}
            {/* <Box className='flex a-center j-center' sx={{height:'40px', width:'40px', backgroundColor:'green', cursor:'pointer',  opacity: pageIndex === 8 && 0.5}} onClick={pageIndex !== 8 ? finishedHandler : null}>\/</Box> */}
            <UpIcon  color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)}  sx={{opacity: pageIndex === 1 && 0.5, fontSize:{xs:'45px', sm:'55px', lg:'65px',xl:'82px'}}} onClick={pageIndex !== 1 ? prevPageHandler : null}/>
            <DownIcon  color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)}  sx={{ cursor:'pointer', fontSize:{xs:'45px', sm:'55px', lg:'65px',xl:'82px'}}} onClick={pageIndex !== 8 ? finishedHandler : null}/>
          </Box>
        </Box>
    </Backdrop>
    </Slide>
    </>
  )
}

export default ProjectNamePage